/**
 * @fileoverview GET handler for the "/apps/app_group" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroup } from "./constants";
import type { AppGroup } from "@lib/dashboardConfig";

export const getAppsAppGroup = reactQueryFetcherAdapter(appsAppGroup, (signal: AbortSignal): Promise<AppGroup> => {
  return fetch("/apps/app_group", "GET", {}, { signal });
});
